import { render, staticRenderFns } from "./SDStatusView.vue?vue&type=template&id=971e7082&scoped=true"
import script from "./SDStatusView.vue?vue&type=script&lang=js"
export * from "./SDStatusView.vue?vue&type=script&lang=js"
import style0 from "./SDStatusView.vue?vue&type=style&index=0&id=971e7082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e7082",
  null
  
)

export default component.exports